import styled from 'styled-components';

const Button = styled.button`
  padding: 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.font.sm};
  font-weight: ${props => props.theme.font.bold};
  color: ${props => props.theme.colors.lightGrey};
  flex-shrink: 0;
  flex-grow: 0;
  display: ${props => (props.hide ? 'none' : 'block')};
  margin: 0;
  
  ${props =>
    props.danger &&
    `
    background: ${props.theme.colors.danger};
    color: ${props.theme.colors.lightGrey};
  `}

  ${props =>
    props.success &&
    `
    background: ${props.theme.colors.success};
    color: ${props.theme.colors.lightGrey};
  `}
  
  ${props =>
    props.auto &&
    `
      height: 40px;
  `};
  
  ${props =>
    props.xs &&
    `
    height: 35px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  `}

  ${props =>
    props.sm &&
    `
    padding: 15px !important;
  `}
  
  ${props =>
    props.md &&
    `
    padding: 15px 20px important;
  `}

  ${props =>
    props.lg &&
    `
    padding: 15px 30px important;
  `}

  ${props =>
    props.marginT &&
    `
    margin-top: ${props.marginT}px;
  `}

  ${props =>
    props.marginR &&
    `
    margin-right: ${props.marginR}px;
  `}

  ${props =>
    props.marginB &&
    `
    margin-bottom: ${props.marginB}px;
  `}

  ${props =>
    props.marginL &&
    `
    margin-left: ${props.marginL}px;
  `}

  &:focus {
    outline: none;
  }

  ${props =>
    props.alignSelf &&
    `
    align-self: ${props.alignSelf};
  `}

  ${props =>
    props.not &&
    `
    opacity: 0.7;
    cursor: not-allowed;
  `}

  ${props =>
    props.inverse &&
    `
    background: #fff;
    color: ${props.theme.colors.primary};
    border: 1px solid ${props.theme.colors.primary};
  `}

  ${props =>
    props.disabled &&
    `
    cursor: not-allowed;
    opacity: 0.7;
  `}
`;

export default Button;
